
function Search() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
    >
      <path
        d="M8.74472 0C3.9255 0 0 3.9255 0 8.74472C0 13.5639 3.9255 17.4894 8.74472 17.4894C10.8404 17.4894 12.765 16.7453 14.2734 15.5099L19.4946 20.7311C19.5752 20.8151 19.6717 20.8821 19.7785 20.9282C19.8853 20.9744 20.0002 20.9988 20.1165 21C20.2329 21.0011 20.3483 20.9791 20.456 20.9351C20.5637 20.8911 20.6616 20.8261 20.7438 20.7438C20.8261 20.6616 20.8911 20.5637 20.9351 20.456C20.9791 20.3483 21.0011 20.2329 21 20.1165C20.9988 20.0002 20.9744 19.8853 20.9282 19.7785C20.8821 19.6717 20.8151 19.5752 20.7311 19.4946L15.5099 14.2734C16.7453 12.765 17.4894 10.8404 17.4894 8.74472C17.4894 3.9255 13.5639 0 8.74472 0ZM8.74472 1.74894C12.6187 1.74894 15.7405 4.8707 15.7405 8.74472C15.7405 12.6187 12.6187 15.7405 8.74472 15.7405C4.8707 15.7405 1.74894 12.6187 1.74894 8.74472C1.74894 4.8707 4.8707 1.74894 8.74472 1.74894Z"
        fill="white"
      />
    </svg>
  );
}

export default Search;
